import React from 'react';
import { TeacherNavigation } from './layout/TeacherNavigation';
import { teacherV2NavItems, TeacherV2NavId } from './layout/v2NavItems';

interface TeacherNavProps {
  activeTab: TeacherV2NavId;
}

export const TeacherNav: React.FC<TeacherNavProps> = ({ activeTab }) => {
  return (
    <details className="mx-auto max-w-7xl border-b border-border bg-surface p-4">
      <summary className="cursor-pointer font-semibold">Teacher menu</summary>
      <div className="mt-3"><TeacherNavigation items={teacherV2NavItems(activeTab)} /></div>
    </details>
  );
};

export default TeacherNav;
